import { render } from "./HomeActuComponent.vue?vue&type=template&id=54b24124"
import script from "./HomeActuComponent.vue?vue&type=script&lang=js"
export * from "./HomeActuComponent.vue?vue&type=script&lang=js"

import "./HomeActuComponent.vue?vue&type=style&index=0&id=54b24124&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__